import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'shared/stored/store';
import { UserRole } from 'shared/types';

interface WithRolesProps extends PropsWithChildren {
  roles: UserRole[];
  fallback?: React.ReactNode;
  requireAuth?: boolean;
}

const WithRoles: React.FC<WithRolesProps> = ({ 
  roles, 
  children, 
  fallback = null,
  requireAuth = true 
}) => {
  const { authenticated, profile } = useSelector((state: RootState) => state.user);
  
  if (requireAuth && !authenticated) {
    return fallback as React.ReactElement;
  }
  
  if (roles.length === 0) {
    return children as React.ReactElement;
  }
  
  const userRole = profile?.roleId;
  const hasAccess = userRole && roles.includes(userRole);
  
  return hasAccess ? (children as React.ReactElement) : (fallback as React.ReactElement);
};

export default WithRoles;
